import { baseUrl } from "../../../utils/apiData";
import "./ContactLanding.scss";

const ContactLanding = ({title, bgImg}) => {
  return (
    <section className="contact_landing">
      
      <div className="img_wrap">
        <img src={`${baseUrl}/${bgImg}`} alt="contact" />
      </div>
      <div className="overlay"></div>
      <div className="text_line">
           <h1 className="small_title wow fadeInUp">{title}</h1>
           </div>
     
    </section>
  );
};

export default ContactLanding;
